import React from 'react';
import { formatPoints } from '../utils/scoring';

interface Props {
  myPoints: number;
  myWorkouts: number;
  myMinutes: number;
  myElo?: number;
  opponentWorkouts: number;
  opponentPoints?: number;
  opponentMinutes?: number;
  opponentElo?: number;
  revealed?: boolean;
  myBet?: { net_points: number; won: number; lost: number } | null;
  oppBet?: { net_points: number; won: number; lost: number } | null;
  myBetCount?: number;
  oppBetCount?: number;
}

function Stat({ value, label }: { value: string | number; label: string }) {
  return (
    <div className="points-stat">
      <span className="points-stat-value">{value}</span>
      <span className="points-stat-label">{label}</span>
    </div>
  );
}

export default function PointsSummary({ myPoints, myWorkouts, myMinutes, myElo, opponentWorkouts, opponentPoints, opponentMinutes = 0, opponentElo, revealed, myBet, oppBet, myBetCount = 0, oppBetCount = 0 }: Props) {
  const showOppPoints = revealed && opponentPoints !== undefined;
  return (
    <div className="points-summary">
      <div className="points-col points-col--mine">
        <Stat value={Math.round(myPoints)} label="Points" />
        <Stat value={myWorkouts} label="Workouts" />
        <Stat value={myMinutes} label="Duration (min)" />
        {/* <Stat value={myBetCount} label="Bets" /> */}
        {myElo !== undefined && <Stat value={myElo} label="🔥 OnFire" />} 
      </div>
      <div className="points-col points-col--opp">
        <Stat value={showOppPoints ? Math.round(opponentPoints!) : '?'} label="Points" />
        <Stat value={opponentWorkouts} label="Workouts" />
        <Stat value={opponentMinutes} label="Duration (min)" />
        {/* <Stat value={oppBetCount} label="Bets" /> */}
        {opponentElo !== undefined && <Stat value={opponentElo} label="🔥 OnFire" />} 
      </div>
    </div>
  );
}
